import { useCallback, useEffect, useMemo, useRef } from 'react';
import { isContains, isObject } from '@arco-design/mobile-utils';
import lodashThrottle from 'lodash.throttle';
import { getDefaultValue } from '../../_helpers';
import { defaultAutoDirection } from './usePosition';
/** 阻止最近一次点击事件计时器 */

export var preventRecentClickTimer = 0;
export var useEvent = function useEvent(props, wrapperRef, popoverInnerRef, visibleRef, onVisibleChange, adjustVerticalDirection) {
  var _props$clickOtherToCl = props.clickOtherToClose,
      clickOtherToClose = _props$clickOtherToCl === void 0 ? true : _props$clickOtherToCl,
      _props$touchOtherToCl = props.touchOtherToClose,
      touchOtherToClose = _props$touchOtherToCl === void 0 ? props.touchToClose === void 0 ? false : props.touchToClose : _props$touchOtherToCl,
      _props$duration = props.duration,
      duration = _props$duration === void 0 ? 0 : _props$duration,
      _props$useAutoDirecti = props.useAutoDirection,
      useAutoDirection = _props$useAutoDirecti === void 0 ? true : _props$useAutoDirecti,
      _props$verticalScroll = props.verticalScrollThrottle,
      verticalScrollThrottle = _props$verticalScroll === void 0 ? 100 : _props$verticalScroll,
      _props$getVerticalScr = props.getVerticalScrollContainer,
      getVerticalScrollContainer = _props$getVerticalScr === void 0 ? function () {
    return document;
  } : _props$getVerticalScr;
  /** 浮窗消失计时器 */

  var closeTimer = useRef(0);
  /** 垂直方向自适应 */

  var autoVerticalDirection = getDefaultValue(isObject(useAutoDirection) ? useAutoDirection.vertical : useAutoDirection, defaultAutoDirection);

  var popoverDisappear = function popoverDisappear(e) {
    onVisibleChange(false); // FIXME: UE要求气泡出现后，点击页面任意元素只隐藏气泡，不响应点击事件

    if (e) {
      e.preventDefault();
    }

    window.clearTimeout(closeTimer.current);
    closeTimer.current = 0;
  };

  var throttleHandleVerticalScroll = useMemo(function () {
    return lodashThrottle(adjustVerticalDirection, verticalScrollThrottle);
  }, [adjustVerticalDirection, verticalScrollThrottle]);
  useEffect(function () {
    var verticalScrollEl = getVerticalScrollContainer();

    if (visibleRef.current && verticalScrollEl && autoVerticalDirection) {
      verticalScrollEl.addEventListener('scroll', throttleHandleVerticalScroll);
    }

    return function () {
      if (verticalScrollEl) {
        verticalScrollEl.removeEventListener('scroll', throttleHandleVerticalScroll);
      }
    };
  }, [throttleHandleVerticalScroll, getVerticalScrollContainer, autoVerticalDirection, visibleRef]);
  var mayRemoveEventListenerOnBody = useCallback(function () {
    document.body.removeEventListener('click', handleClickBody);
    document.body.removeEventListener('touchstart', handleTouchBody);
    var el = getVerticalScrollContainer();

    if (el) {
      el.removeEventListener('scroll', throttleHandleVerticalScroll);
      el.removeEventListener('scroll', handleScrollBody);
    }
  }, [throttleHandleVerticalScroll]);
  var handleClickBody = useCallback(function (e) {
    var _popoverInnerRef$curr;

    // 仅处理子元素和气泡元素外的点击事件
    if (!isContains(wrapperRef.current, e.target) && !isContains(((_popoverInnerRef$curr = popoverInnerRef.current) == null ? void 0 : _popoverInnerRef$curr.dom) || null, e.target)) {
      e.stopPropagation();
      popoverDisappear(e);
    }
  }, []);
  /**
   * UE要求气泡出现后，点击页面任意元素只隐藏气泡，不响应点击事件
   * 由于touchstart不能取消点击事件
   * 监听body的最近一次click事件进行取消
   * 如果500ms内没有点击事件，用户可能是通过滑动页面触发的touchstart，此时移除click监听
   */

  var preventRecentClick = function preventRecentClick() {
    clearTimeout(preventRecentClickTimer);

    var handle = function handle(e) {
      e.stopPropagation();
      e.preventDefault();
      document.body.removeEventListener('click', handle);
      clearTimeout(preventRecentClickTimer);
    };

    document.body.addEventListener('click', handle);
    preventRecentClickTimer = window.setTimeout(function () {
      document.body.removeEventListener('click', handle);
    }, 500);
  };

  var handleTouchBody = useCallback(function (e) {
    var _e$targetTouches$, _popoverInnerRef$curr2, _e$targetTouches$2, _e$targetTouches$3;

    if (!((_e$targetTouches$ = e.targetTouches[0]) != null && _e$targetTouches$.target) || !wrapperRef.current || !((_popoverInnerRef$curr2 = popoverInnerRef.current) != null && _popoverInnerRef$curr2.dom) || !visibleRef.current) {
      return;
    } // 判断元素是否非子元素和气泡元素，内部的事件交给组件内部自行处理


    if (!isContains(wrapperRef.current, (_e$targetTouches$2 = e.targetTouches[0]) == null ? void 0 : _e$targetTouches$2.target) && !isContains(popoverInnerRef.current.dom, (_e$targetTouches$3 = e.targetTouches[0]) == null ? void 0 : _e$targetTouches$3.target)) {
      preventRecentClick();
      popoverDisappear(e);
    }
  }, []);
  var handleScrollBody = useCallback(function () {
    if (visibleRef.current && touchOtherToClose) {
      popoverDisappear();
    }
  }, [touchOtherToClose]);
  useEffect(function () {
    var el = getVerticalScrollContainer();

    if (el && touchOtherToClose && visibleRef.current) {
      el.addEventListener('scroll', handleScrollBody);
    }

    return function () {
      el && el.removeEventListener('scroll', handleScrollBody);
    };
  }, [handleScrollBody, touchOtherToClose]);

  var mayAddEventOnBody = function mayAddEventOnBody() {
    if (touchOtherToClose) {
      document.body.addEventListener('touchstart', handleTouchBody); // FIXME: 解决按住气泡元素后上下滚动页面，气泡未消失的问题

      var el = getVerticalScrollContainer();
      el && el.addEventListener('scroll', handleScrollBody);
    } else if (clickOtherToClose) {
      document.body.addEventListener('click', handleClickBody);
    }
  };
  /**
   * 气泡自动关闭的场景下，计时关闭气泡
   */


  var startCloseTimer = function startCloseTimer() {
    if (duration !== 0) {
      closeTimer.current = window.setTimeout(function () {
        onVisibleChange(false);
        mayRemoveEventListenerOnBody();
      }, duration);
    }
  };

  return {
    popoverDisappear: popoverDisappear,
    mayRemoveEventListenerOnBody: mayRemoveEventListenerOnBody,
    startCloseTimer: startCloseTimer,
    mayAddEventOnBody: mayAddEventOnBody
  };
};